import ProgressAndDonations from './ProgressAndDonations'

export default ProgressAndDonations
